import styles from "./UpcomingActionItem.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";

/**
 *
 * Displays the information of an upcoming action. An exclamation point icon in the status column signifies an overdue action. Clicking on the incident number will take the user to the incident details page.
 *
 */

export function UpcomingActionItem({
  index,
  actionDetails,
  onClick,
  clearReminder,
}) {
  const shortNumber = actionDetails.id.substring(0, 8) + "...";

  const currentDate = new Date();

  const timeDiff = Math.ceil(
    Math.abs(currentDate.getTime() - actionDetails.reminderDate.getTime()) /
      (1000 * 3600 * 24)
  );
  const dayText = timeDiff === 1 ? "day" : "days";
  const dateDisplay = `${timeDiff} ${dayText} ${
    actionDetails.reminderDate < currentDate ? "ago" : "away"
  }`;

  return (
    <div
      className={classNames(styles.container, index % 2 !== 0 && styles.gray)}
    >
      <Link to={`/security/incident/${actionDetails.id}`}>
        <div
          className={classNames(styles.gridItem, styles.link)}
          onClick={onClick}
        >
          {shortNumber}
        </div>{" "}
      </Link>
      <div className={styles.gridItem}>{actionDetails.reason}</div>
      <div className={styles.gridItem}>{dateDisplay}</div>
      {/* {actionDetails.reminderDate < currentDate && (
        <div className={styles.lastItem}>
          <div className={styles.circle}>
            <div className={styles.circleExclamationPoint}>X</div>
          </div>
        </div>
      )} */}
      <div className={styles.lastItem}>
        <div
          className={styles.circle}
          onClick={() =>
            clearReminder(actionDetails.id, actionDetails.reminderId || "")
          }
        >
          <div className={styles.circleExclamationPoint}>X</div>
        </div>
      </div>
    </div>
  );
}

UpcomingActionItem.propTypes = {
  index: PropTypes.number,
  actionDetails: PropTypes.object,
  onClick: PropTypes.func,
};
